import ErrorBoundary from "../ErrorBoundary";
import React from 'react';
import BaseSubGridPanel from "../Base/BaseSubGridPanel";

const keyName = `HuntCodesSub`;

export default class HuntCodesSub extends BaseSubGridPanel {

    constructor(props) {
        super(props);
        if (window.IasConfig.devMode) console.debug(`${keyName} constructor`, props);
        const context = this;
        context.gridName=`HuntCodesSubGrid`;
    }

    //заголовок окна
    setDialogTitle(context) {
        context.dialog.cmp.setTitle(`Коды охотпользователя ${context.grid.getCurrentRow()[`user_name`]}`);
    }

}

